<template>
  <TxtPage>
    
    <div slot="return-content" class="btn-return">
      <router-link :to="{ name: 'Labels' }" >
        <img src="../../assets/arrow.svg" />
      </router-link>
    </div>
    
    <div slot="left-content" class="spacer-content">
      <div class="title">Innovations <span>et Services</span></div>
      <img src="../../assets/respiration.svg" class="picto"/>
      <div class="subtitle">Une méthode innovante pour intégrer la qualité de l’air intérieur tout au long de l’acte de construire </div>
      <div class="text">La méthode repose sur des recommandations méthodologiques et techniques qui concernent quatre thématiques essentielles à une meilleure Qualité de l’Air Intérieur : 
        <ul class="list-style-custom">
          <li>La prise en compte des sources de pollution atmosphériques </li>
          <li>La gestion des polluants provenant du sol</li>
          <li>La limitation des sources de pollution intérieures par le choix de produits de construction et finitions respectueux et faiblement émissifs</li>
          <li>La maîtrise et la garantie de l’efficacité des systèmes et des équipement</li>
        </ul>
      </div>
      <img src="../../assets/cloche.svg" class="picto"/>
      <div class="text">Une conciergerie digitale sera mise à disposition des résidants : un gain de temps assuré, une qualité de vie retrouvée.</div>
      <img src="../../assets/bike.svg" class="picto"/>
      <div class="text">
        L’usage du vélo s’inscrit les mobilités décarbonées dans l’ADN de la résidence et comme modes de vie pour qu’il devienne un réflexe au quotidien. 	
        <br /><br />Les locaux vélos, accessible depuis les 2 halls et traités habillement architecturalement donnent à ce mode de déplacement un écrin soigné et pratique au quotidien pour inciter à son utilisation. Le parti pris est de renverser cette tendance qui consiste à considérer le local vélo comme une contrainte réglementaire, pour en faire un vrai espace de vie plus ouvert à la ville et ses usagers. 
      </div>
      <img src="../../assets/meuble.svg" class="picto"/>
      <div class="text">
        Chaque espace est dédié à une fonctionnalité précise et participe de l’amélioration du bien-être pour chacun, et du confort d’usage au sein des logements. 	
        <br /><br />Il s’agit de faire émerger çà et là dans l’immeuble des espaces multiples et différenciés, orientés vers le bien-être ou l’amélioration de l’habitat. 	
        <br /><br />Vous retrouverez dans chaque bâtiment un atelier de bricolage, un espace yoga et une bibliothèque.
      </div>
      <img src="../../assets/nature.svg" class="picto"/>
      <div class="text">
        En rooftop, vous découvrirez votre jardin pédagogique conçu pour vous ressourcer et limiter le stress quotidien. Détendez-vous et profitez des vue panoramiques sur tout Paris. 
        <br /><br />Les parcours pédagogiques autour des sens et des plantes comestibles seront le moyen de sensibiliser les habitants à l’agriculture urbaine et ses bienfaits pour la santé.
      </div>
      <img src="../../assets/panier.svg" class="picto"/>
      <div class="text">
        Les petits marchés alimentaires en cœur d’ilot, vous proposent des produits frais issus de circuits courts afin de vous offrir le choix de mieux consommer.
      </div>
      <!--BTN-->
      <div class="btn-scroll"><img src="../../assets/scroll.svg" /></div>
    </div>
    
    <div slot="right-content">
      <img src="../../assets/pers-labels-innovations.jpg" class="cover-center"/>
    </div>
    
  </TxtPage>
</template>

<script>
// @ is an alias to /src

import TxtPage from '@/components/TxtPage.vue';

export default {
  name: 'InnovationsServices',
  components: {
    TxtPage
  },
  data: () => {
      
        return { 
            
        };
    },
  
};
</script>